
     <form [formGroup]="formEdit" >
      <mat-dialog-content>
        <mat-form-field>
            <input matInput formControlName="content" placeholder={{fieldName}} autocomplete="off">
        </mat-form-field>
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <button mat-raised-button  (click)="save()">OK</button>
      </mat-dialog-actions>
    </form>
  